
import moment from 'moment';
import LZString from 'lz-string';

const cacheKey = 'print-data';

export function generatePrintableWindow(momentSignature) {
    const url = getPrintableUrl(momentSignature);
    const win = window.open(url, '_blank');
    win.postMessage('hello', window.location.origin);
    win.focus();
}

export function getLocalPrintData() {
    try {
        const localData = localStorage.getItem(cacheKey);
        const decompressedData = LZString.decompress(localData);
        return JSON.parse(decompressedData) ?? {};
    } catch (e) {
        console.error('Error parsing local print data:', e);
        return {};
    }
}

export function storeLocalPrintData(currentPrintData, newResult, currentMS = null) {
    const momentSignature = currentMS ?? moment().toISOString();
    currentPrintData[momentSignature] = newResult;
    let serializedPrintData = LZString.compress(JSON.stringify(currentPrintData));

    updatePrintData(serializedPrintData);
    return momentSignature;
}

export function updatePrintData(serializedPrintData) {
    try {
        localStorage.setItem(cacheKey, serializedPrintData);
    } catch (e) {
        localStorage.removeItem(cacheKey);
        localStorage.setItem(cacheKey, serializedPrintData);
    }
}

function getPrintableUrl(ms) {
    const getUrl = window.location;
    const baseUrl = getUrl.protocol +
        '//' +
        getUrl.host +
        '/' +
        getUrl.pathname.split('/')[1];
    const url = `${baseUrl}/api/printable?print-id=${ms}`;
    return url;
}